module.exports = __webpack_public_path__ + "img/full4-min.a7247669.png";